<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("stock_issue_voucher")}}</h4>
                <p class="text-subtitle-1">{{$t("issue_stock_from_inventory")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <StockJournalView type="GOODS_ISSUE"/>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value"></PAlert>
    </v-container>
</template>

<script>

import StockJournalView from './StockJournalView';

export default {
    components: { StockJournalView },
    name: "GoodsIssue",
    data() {
        return {
            breadcrumbs: [
                { text: "Inventory Management" },
                { text: "Stock Movement" },
                { text: "Goods Issue" },
            ],
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            }
        };
    },
    
};
</script>
